import { render, staticRenderFns } from "./StoreItemsTabs.vue?vue&type=template&id=96b9e372&"
import script from "./StoreItemsTabs.vue?vue&type=script&lang=js&"
export * from "./StoreItemsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports